import { em } from '@mantine/core';

const APP_CONFIG = {
	QUERY_STALE_TIME: 30_000,
	QUERY_CACHE_TIME: 1_800_000,
	QUERY_RETRY: 2,
	Z_INDEX: {
		CSS_2D_RENDERER: 5,
		TOOLBAR: 10,
		OVERLAY: 50,
		SCROLL_TOP: 50,
		NOTIFICATION: 100,
		MOBILE_TOOLBAR: 300,
		DRAWER: 301,
		MODAL: 301,
		POPOVER: 302,
		TOOLTIP: 302,
		SELECT: 302,
		CREATOR_LOADING: 303,
		MODEL_VIEWER: 304,
		MODAL_INSTRUCTION: 504,
	},
	BREAKPOINTS: {
		XS: em(576),
		SM: em(768),
		MD: em(992),
		LG: em(1200),
		XL: em(1408),
	},
	DEFAULT_LANGUAGE: 'PL',
	HOTKEYS: {
		TOGGLE_TRANSFORM_MODE: 't',
	},
	MOBILE_DRAWER_SWIPE_STEP_THRESHOLD: 150,
	WALA_URL: 'https://www.wala.pl/',
	LED_POINTS: {
		MAX_QUANTITY: 5,
	},
	MIDDLE_POST: {
		AUTO_SPACING_DISTANCE: 600,
	},
	STORAGE_KEYS: {
		TEMP_PROJECT: 'tempProject',
		CART: 'cart',
		USER_DATA: 'userData',
	},
	AUTO_SAVE_INTERVAL: 30_000,
	AVAILABLE_LANGUAGES: [
		{ value: 'PL', label: 'Polska' },
		{ value: 'DE', label: 'Niemcy' },
		{ value: 'GB', label: 'Wielka Brytania' },
		{ value: 'FR', label: 'Francja' },
		{ value: 'IT', label: 'Włochy' },
		{ value: 'ES', label: 'Hiszpania' },
		{ value: 'CZ', label: 'Czechy' },
		{ value: 'SK', label: 'Słowacja' },
		{ value: 'UA', label: 'Ukraina' },
		{ value: 'BY', label: 'Białoruś' },
		{ value: 'LT', label: 'Litwa' },
		{ value: 'LV', label: 'Łotwa' },
		{ value: 'EE', label: 'Estonia' },
		{ value: 'RO', label: 'Rumunia' },
		{ value: 'HU', label: 'Węgry' },
		{ value: 'AT', label: 'Austria' },
		{ value: 'CH', label: 'Szwajcaria' },
		{ value: 'NL', label: 'Holandia' },
		{ value: 'BE', label: 'Belgia' },
		{ value: 'DK', label: 'Dania' },
		{ value: 'SE', label: 'Szwecja' },
		{ value: 'NO', label: 'Norwegia' },
		{ value: 'FI', label: 'Finlandia' },
	],
} as const;

export default APP_CONFIG;
